import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { Observable } from 'rxjs';
import { ReplaySubject } from 'rxjs';

@Injectable()
export class AppPopoversService {
  private open$: Subject<{
    id: string;
    callback1: Function;
    callback2: Function;
    options: Object;
  }> = new ReplaySubject<{
    id: string;
    callback1: Function;
    callback2: Function;
    options: Object;
  }>(null);
  private close$: Subject<string> = new ReplaySubject<string>(null);
  private scrollOffset: number;

  open(
    data: string,
    callback1?: Function,
    callback2?: Function,
    options?: Object
  ) {
    this.open$.next({
      id: data,
      callback1: callback1,
      callback2: callback2,
      options: options
    });
  }

  close(data: string) {
    this.close$.next(data);
  }

  public openStream(): Subject<{
    id: string;
    callback1: Function;
    callback2: Function;
    options: Object;
  }> {
    return this.open$;
  }

  public closeStream(): Subject<any> {
    return this.close$;
  }

  /*
     Because of a scroll issue on mobile we have to set body as fixed and set top offset when modal is open
     */
  public onShow(): void {
    this.scrollOffset = this.scrollOffset
      ? this.scrollOffset
      : document.body.scrollTop;
    document.body.style.top = '-' + this.scrollOffset + 'px';
  }

  /*
     Scroll back to same location as before modal open
     */
  public onHide(): void {
    document.body.style.top = '0';
    window.scroll(0, this.scrollOffset);
    this.scrollOffset = null;
  }
}
